const About = ({ styles }) => {
  return (
    <div>
      <h1>About the Project</h1>
      <p>This project from the University of Kansas was done in collaboration with the Spencer Museum of Art, the Institute for Information Sciences, and artists Simon Denny and Stephanie Dinkins. </p>
      <p>This project explores ideas of ownership in digital spaces by the distribution of claim NFTs and examination of the behavior of their owners.</p>
      <h1>About this System</h1>
      <p>This system enables the generation of wallets distribution of Claim NFTs into them. Click the Generate page to see how wallets are generated and distributed. Wallet owners can then click the Claim button to verify that they are an owner and attempt to claim land. </p>
    </div>
  );
}
export default About;